import type { SVGProps } from 'react';

const SvgAssetTypeImage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M18 4.98H6c-1.65 0-3 1.35-3 3v8c0 1.65 1.35 3 3 3h12c1.65 0 3-1.35 3-3v-8c0-1.65-1.35-3-3-3m-12 2h12c.55 0 1 .45 1 1v4l-2.4-1.8a.99.99 0 0 0-1.22.02l-4.43 3.54-2.39-1.59a.99.99 0 0 0-1.15.03l-2.4 1.8v-6c0-.55.45-1 1-1zm12 10H6c-.4 0-.74-.24-.9-.58l2.93-2.2 2.41 1.61c.36.24.84.22 1.18-.05l4.39-3.52 2.98 2.23v1.5c0 .55-.45 1-1 1z"
    />
    <path
      fill="currentcolor"
      d="M11.5 10.98a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
    />
  </svg>
);
export default SvgAssetTypeImage;
